<template>
	<div>
		<v-lt-cp-resgate-pontos-selecionar-premios ref="listagem"></v-lt-cp-resgate-pontos-selecionar-premios>
		<vue-element-loading :active="loading" spinner="bar-fade-scale" is-full-screen/>
	</div>
</template>
<script>
export default {
	props: { },
	data() { return { loading: false } },
	methods: { }
}
</script>